import { axiosInstance } from "./networking";

// Shared TinyMCE settings for every email editor. A pasted or dropped image
// would otherwise be embedded as a multi-megabyte base64 data: URI in the HTML
// body — which then gets stored per recipient on the server and mailed to
// everyone (and Gmail/Outlook don't even render data: images). With these
// settings TinyMCE uploads the image to the API right after paste and swaps in
// the hosted URL; the server also externalizes anything that slips through.
export const uploadEditorImage = async (blobInfo: any): Promise<string> => {
  const form = new FormData();
  form.append("file", blobInfo.blob(), blobInfo.filename());
  const res = await axiosInstance.post("/broadcast/image", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const url = res?.data?.url;
  if (typeof url !== "string" || !url) {
    throw new Error(res?.data?.error || "Image upload failed");
  }
  return url;
};

export const editorImageUploadInit = {
  paste_data_images: true,
  automatic_uploads: true,
  images_upload_handler: uploadEditorImage,
  images_reuse_filename: false,
  images_file_types: "jpeg,jpg,png,gif,webp",
  // Keep hosted image URLs absolute — the API origin differs from the SPA's.
  relative_urls: false,
  remove_script_host: false,
};

// Call before reading editor content for a send/save: forces any image still
// pending upload (e.g. pasted a moment ago) to be uploaded and its src
// replaced, so the HTML we submit references files, not base64.
export const flushEditorImages = async (editor: any): Promise<void> => {
  if (!editor || typeof editor.uploadImages !== "function") return;
  try {
    await editor.uploadImages();
  } catch (err) {
    console.error("Editor image upload failed:", err);
  }
};
